/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Select from "react-select";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { MultiSelect } from "react-multi-select-component";
import Constants from "variables/Constants";
class AddNewCourseStrategy extends Component {
  state = {
    getAllStrategies: [],
    strategies: [],
    allStrategies: [],
    products: [],
    productIds: [],
    redirect: false,
    notification: false,
    loading: false,
    id: "",
    strategy: [],
    facetofaceAll: [], // For dropdown options
    facetoface: [], // For selected values
    initialStrategies: [],
    initialFacetoface: null,
    showNoChangeModal: false,
  };

  componentDidMount() {
    //console.log("hii");
    let courseId = window.location.pathname.split("/")[3];
    console.log("Course ID", courseId);
    this.setState(
      {
        id: courseId,
      },
      () => {
        console.log(this.state.id);
      },
    );
    // axios.post(axios.get(Constants.getUrls.strategy)
    //   .then((resp)=>{
    //     console.log(resp)
    // resp.data.strategies.map((v)=>{
    //   this.state.strategies.push({
    //     label: v.course.TITLE + "( " + v.duration + " Days)",
    //     value: v.id
    //   })

    // })
    // this.setState({
    //   strategies: this.state.strategies
    // }, ()=>{console.log(this.state.strategies)})
    // })
    let payload = {
      course_id: courseId,
    };

    axios.post(Constants.getUrls.getCourseStrategies, payload).then((resp) => {
      const mappedStrategies = resp.data.strategies_course.map((v) => ({
        label: v.course.TITLE + " (" + v.duration + " Days)",
        value: v.id,
      }));

      //console.log("MAPPED STRATEGIES", mappedStrategies);

      this.setState({
        strategies: mappedStrategies,
        initialStrategies: [...mappedStrategies],
      });
    });

    axios.get(Constants.getUrls.strategy).then((res) => {
      const getAllStrategies = res.data.map((v) => ({
        label: v.course.TITLE + " (" + v.duration + " Days)",
        value: v.id,
      }));

      this.setState({ getAllStrategies });
    });

    this.facetofaceAllValue();
  }

  // facetofaceAllValue = async () => {
  //   try {
  //     const response = await axios.get(
  //       "https://admin.akclasses.in/api/courses?type=COURSES&per_page=10&attempt_id=&lang=&category_id=&level_id=&stream_id=&subject_id=",
  //     );

  //     const courses = response.data.data;
  //     const ftofBatches = courses[0]?.ftofbatches || [];

  //     const formattedOptions = ftofBatches.map((batch) => ({
  //       label: batch.batch_name,
  //       value: batch.id,
  //     }));

  //     this.setState({
  //       facetofaceAll: formattedOptions,
  //       facetoface: null, // 👈 No default selected
  //       initialFacetoface: null,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching strategies:", error);
  //   }
  // };

  facetofaceAllValue = async () => {
    try {
      const response = await axios.get(
        "https://admin.akclasses.in/api/courses?type=COURSES&per_page=10&attempt_id=&lang=&category_id=&level_id=&stream_id=&subject_id=",
      );

      const courses = response.data.data;

      const courseById = courses?.find((course) => course.ID == this.state.id);

      //console.log("FILTERED COURSE DATA", courseById);

      const ftofBatches = courses[0]?.ftofbatches || [];
      const selectedFtofBatchId = courseById?.ftofbatch;
      //console.log("Selected Batch  ", courseById);

      // Format data for Select
      const formattedOptions = ftofBatches.map((batch) => ({
        label: batch.batch_name,
        value: batch.id,
      }));

      //console.log("Formatted Options:", formattedOptions);

      // Find the selected batch if any
      const selectedBatch = formattedOptions.find(
        (batch) => batch.value === selectedFtofBatchId,
      );

      // Set facetoface as a single selected batch object
      this.setState({
        facetofaceAll: formattedOptions,
        facetoface: selectedBatch || null,
        initialFacetoface: selectedBatch,
      });
    } catch (error) {
      console.error("Error fetching strategies:", error);
    }
  };

  // comparer = otherArray => {
  //   return function(current) {
  //     return (
  //       otherArray.filter(function(other) {
  //         return other.id == current.id;
  //       }).length == 0
  //     );
  //   };
  // };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const {
      strategies,
      facetoface,
      initialStrategies,
      initialFacetoface,
    } = this.state;

    const strategyIds = strategies.map((v) => v.value);
    const facetofaceId = facetoface ? facetoface.value : null;

    const strategyPayload = {
      course_id: this.state.id,
      strategies: strategyIds,
    };

    const ftofBatchPayload = {
      courseid: this.state.id,
      ftofbatch: facetofaceId,
    };

    const promises = [];

    // Compare strategies
    const strategyChanged = (() => {
      const current = (strategies || [])
        .map((v) => v.value)
        .sort()
        .join(",");
      const initial = (initialStrategies || [])
        .map((v) => v.value)
        .sort()
        .join(",");
      return current !== initial;
    })();

    if (strategyChanged) {
      promises.push(
        axios.post(
          "https://admin.akclasses.in/api/course_With_strategy",
          strategyPayload,
        ),
      );
    }

    // Compare face to face batch
    const ftofChanged =
      !initialFacetoface ||
      initialFacetoface.value !== (facetoface ? facetoface.value : null);

    if (ftofChanged) {
      promises.push(
        axios.post(
          "https://admin.akclasses.in/api/add_ftofbatch",
          ftofBatchPayload,
        ),
      );
    }

    if (promises.length === 0) {
      this.setState({ loading: false, showNoChangeModal: true });
      return;
    }

    Promise.all(promises)
      .then(() => {
        setTimeout(() => {
          this.setState({
            redirect: true,
          });
        }, 1000);

        this.setState({
          notification: true,
          loading: false,
          // Update initial values after submit
          initialStrategies: this.state.strategies,
          initialFacetoface: this.state.facetoface,
        });

        this.facetofaceAllValue();
      })
      .catch((error) => {
        console.error("Submission error:", error);
        this.setState({ notification: true, loading: false });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/admin/newcoursemaster"} />;
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Strategies Added!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Course Strategies</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer>
                      <GridItem
                        style={{ marginTop: "11px" }}
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                      >
                        <div
                          style={{
                            position: "relative",
                            bottom: "11px",
                            border: "none",
                          }}
                        >
                          <label htmlFor="Courses">Strategies</label>
                          <MultiSelect
                            disableSearch
                            options={this.state.getAllStrategies}
                            value={this.state.strategies}
                            onChange={(data) => {
                              this.setState({ strategies: data }, () =>
                                console.log(this.state.strategies),
                              );
                            }}
                            labelledBy={"Strategies"}
                          />
                        </div>
                      </GridItem>
                      <GridItem
                        style={{ marginTop: "11px" }}
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                      >
                        <div
                          style={{
                            position: "relative",
                            bottom: "11px",
                            border: "none",
                          }}
                        >
                          <label htmlFor="Courses">Face to Face</label>
                          <Select
                            options={this.state.facetofaceAll}
                            value={this.state.facetoface} // Set value to the single selected batch object
                            onChange={(selectedOption) => {
                              this.setState(
                                { facetoface: selectedOption }, // Update with the selected batch object
                                () => console.log(this.state.facetoface),
                              );
                            }}
                            placeholder="Select Batch"
                          />
                          {/* <label htmlFor="Courses">Face to Face</label>

                          <Select
                            options={this.state.facetofaceAll}
                            value={this.state.facetoface} // null by default
                            onChange={(selectedOption) => {
                              this.setState({ facetoface: selectedOption });
                            }}
                            placeholder="Select Batch"
                            isClearable={true} // optional but recommended
                          /> */}
                        </div>
                      </GridItem>

                      {this.state.allStrategies.length >= 1 ? (
                        <GridItem xs={12} sm={12} md={12}>
                          <table
                            style={{
                              width: "100%",
                              border: "1px black solid",
                              borderCollapse: "collapse",
                            }}
                          >
                            <tr
                              style={{
                                border: "1px black solid",
                                borderCollapse: "collapse",
                              }}
                            >
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  border: "1px black solid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                Sr.No
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  border: "1px black solid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                Strategy
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  border: "1px black solid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                Days
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  border: "1px black solid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                Action
                              </th>
                            </tr>
                            {this.state.allStrategies.map((v, i) => (
                              <tr
                                style={{
                                  border: "1px black solid",
                                  borderCollapse: "collapse",
                                }}
                                key={i}
                              >
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    border: "1px black solid",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  {i + 1}
                                </td>
                                <td
                                  style={{
                                    padding: "4px 10px 4px 10px",
                                    textAlign: "center",
                                    border: "1px black solid",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  {v.label}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    border: "1px black solid",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  {v.duration == null ? "" : v.duration}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    border: "1px black solid",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <input
                                    style={{
                                      backgroundColor: "red",
                                      borderRadius: "10%",
                                      border: "none",
                                      padding: "10px",
                                      color: "white",
                                    }}
                                    onClick={() => {
                                      this.state.allStrategies.splice(i, 1);
                                      this.setState({
                                        allStrategies: this.state.allStrategies,
                                      });
                                      axios
                                        .post(
                                          "https://admin.akclasses.in/api/deleteAssignedStrategy",
                                          {
                                            course_id: this.state.course_id,
                                            strategy_id: v.id,
                                          },
                                        )
                                        .then((resp) => {
                                          console.log(resp);
                                        });
                                    }}
                                    type="button"
                                    value="Delete"
                                  />
                                </td>
                              </tr>
                            ))}
                          </table>
                        </GridItem>
                      ) : null}

                      <GridItem xs={12} sm={12} md={12}>
                        <Button className="" color="warning" type="submit">
                          {this.state.loading ? (
                            <Loader />
                          ) : (
                            "Add Course Strategies"
                          )}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/newcoursemaster",
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>

                    {this.state.showNoChangeModal && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 9999,
                        }}
                      >
                        <div
                          style={{
                            background: "#fff",
                            padding: "30px",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                            textAlign: "center",
                            maxWidth: "400px",
                            width: "90%",
                          }}
                        >
                          <h4 style={{ marginBottom: "20px" }}>
                            No changes to save
                          </h4>
                          <Button
                            color="primary"
                            onClick={() =>
                              this.setState({ showNoChangeModal: false })
                            }
                          >
                            OK
                          </Button>
                        </div>
                      </div>
                    )}
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default AddNewCourseStrategy;
